import { actions } from './actions';

export const festivalYear = {
  state: {
    festivals: { data: [] },
    festival: {
      paragraphs: [
        {
          content: '',
        },
      ],
    },
    skills: { data: [] },
    skill: {
      paragraphs: [
        {
          content: '',
        },
      ],
    },
    activityInfos: { data: [] },
    activityInfo: {
      paragraphs: [
        {
          content: '',
        },
      ],
    },
    newInfos: { data: [] },
    newInfo: {
      paragraphs: [
        {
          content: '',
        },
      ],
    },
    englishes: { data: [] },
    english: {
      paragraphs: [
        {
          content: '',
        },
      ],
    },
    history: {
      data: []
    }
  },
  getters: {
    festivals(state) {
      return state.festivals;
    },
    festival(state) {
      return state.festival;
    },
    skills(state) {
      return state.skills;
    },
    skill(state) {
      return state.skill;
    },
    activityInfos(state) {
      return state.activityInfos;
    },
    activityInfo(state) {
      return state.activityInfo;
    },
    newInfos(state) {
      return state.newInfos;
    },
    newInfo(state) {
      return state.newInfo;
    },
    englishes(state) {
      return state.englishes;
    },
    english(state) {
      return state.english;
    },
    history(state) {
      return state.history
    }
  },
  mutations: {
    setFestivals(state, payload) {
      state.festivals = payload;
    },
    setFestival(state, payload) {
      state.festival = payload;
    },
    setSkills(state, payload) {
      state.skills = payload;
    },
    setSkill(state, payload) {
      state.skill = payload;
    },
    setActivityInfos(state, payload) {
      state.activityInfos = payload;
    },
    setActivityInfo(state, payload) {
      state.activityInfo = payload;
    },
    setNewInfos(state, payload) {
      state.newInfos = payload;
    },
    setNewInfo(state, payload) {
      state.newInfo = payload;
    },
    setEnglishes(state, payload) {
      state.englishes = payload;
    },
    setEnglish(state, payload) {
      state.english = payload;
    },
    setHistory(state, payload) {
      if (payload.retrospects) {
        state.history = {
          ...payload.retrospects,
          data: payload.retrospects.data.map(item => item.data)
        }
      } else {
        state.history = {
          data: []
        }
      }
    },
  },
  actions,
};
